import { DTOScimMeta } from "./meta";
import { z } from "zod";
export const DTOServiceProviderConfigPatch = z.object({
    supported: z.boolean(),
});
export const DTOServiceProviderConfigBulk = z.object({
    supported: z.boolean(),
    maxOperations: z.number(),
    maxPayloadSize: z.number(),
});
export const DTOServiceProviderConfigFilter = z.object({
    supported: z.boolean(),
    maxResults: z.number(),
});
export const DTOServiceProviderConfigChangePassword = z.object({
    supported: z.boolean(),
});
export const DTOServiceProviderConfigSort = z.object({
    supported: z.boolean(),
});
export const DTOServiceProviderConfigETag = z.object({
    supported: z.boolean(),
});
export const DTOServiceProviderConfigAuthenticationScheme = z.object({
    name: z.string(),
    description: z.string(),
    specUri: z.string().optional(),
    documentationUri: z.string().optional(),
    type: z.string(),
    primary: z.boolean(),
});
export const DTOServiceProviderConfig = z.object({
    schemas: z
        .array(z.string())
        .default(["urn:ietf:params:scim:schemas:core:2.0:ServiceProviderConfig"]),
    documentationUri: z.string().optional(),
    patch: DTOServiceProviderConfigPatch,
    bulk: DTOServiceProviderConfigBulk,
    filter: DTOServiceProviderConfigFilter,
    changePassword: DTOServiceProviderConfigChangePassword,
    sort: DTOServiceProviderConfigSort,
    eTag: DTOServiceProviderConfigETag,
    authenticationSchemes: z.array(DTOServiceProviderConfigAuthenticationScheme),
    meta: DTOScimMeta,
});
